import { IAppReducer } from '../Interfaces/IAppReducer';
import { IUser } from '../Interfaces/IUser';

export const userInitState: IUser = {
  id: 0,
  name: '',
  surname: '',
  email: '',
  avatar: '',
  roles: [],
  github: '',
  showGithubWarning: false,
  redirect: {
    payload: null,
    type: null,
  },
};

const appInitState: IAppReducer = {
  user: userInitState,
};

export default appInitState;
